import { type PropsWithChildren } from "react"
import { Typography } from "@octopus-energy/coral/atoms"

export function PageSubtitle({ children }: PropsWithChildren) {
    return <Typography textStyle="h4">{children}</Typography>
}
